import { mediaHoverable } from 'lib/theme/mediaQueries'
import type { ComponentProps, HTMLAttributes, ReactElement, RefAttributes } from 'react'
import React from 'react'
import styled from 'styled-components'
import interactiveFocusStyle from 'styles/utils/interactiveFocusStyle'
import _ListItem from './_ListItem'

const Container = styled(_ListItem)`
  &:has(input:disabled) {
    color: ${props => props.theme.palette.neutral.default.four};
  }

  &:not(:has(input:disabled)) {
    ${mediaHoverable} {
      &:hover {
        cursor: pointer;
        background-color: ${props => props.theme.palette.neutral.default.seven};
      }
    }

    &:focus {
      ${interactiveFocusStyle}
    }
  }
`

type InheritedBaseListItemProps = Omit<ComponentProps<typeof _ListItem>, 'ref' | 'as' | 'startIcon' | 'endIcon' | 'selected' | 'disabled'>

interface Props extends Omit<HTMLAttributes<HTMLLabelElement>, 'title'>, InheritedBaseListItemProps, RefAttributes<HTMLLabelElement> {
  /**
   * Either a `<RadioButton>` or `<CheckboxButton>`
   */
  input: ReactElement
  /**
   * Determines on which end of the list item the input element should be placed.
   */
  inputPlacement: 'start' | 'end'
  /** This icon will be placed on the opposite side to where the input is placed */
  icon?: ReactElement | false
}

function InputLabelListItem({
  input,
  inputPlacement,
  icon,
  ...rest
}: Props) {
  return <Container
    {...rest}
    forwardedAs={'label' as any}
    startIcon={inputPlacement === 'start' ? input : icon}
    endIcon={inputPlacement === 'end' ? input : icon}
  />
}

export default InputLabelListItem
